export default __webpack_public_path__ + "static/media/inside3.bd70902d.jpg";